import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const ErrorFill16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M8 1C8.52175 1 9.02212 1.20726 9.39106 1.57619L14.4238 6.60894C14.7927 6.97787 15 7.47825 15 8C15 8.52175 14.7927 9.02213 14.4238 9.39106L9.39106 14.4238C9.02213 14.7927 8.52175 15 8 15C7.47825 15 6.97787 14.7927 6.60894 14.4238L1.57619 9.39106C1.20726 9.02213 1 8.52175 1 8C1 7.47825 1.20726 6.97787 1.57619 6.60894L6.60894 1.57619C6.97787 1.20726 7.47825 1 8 1ZM5.71536 5.71536C6.00251 5.42821 6.46808 5.42821 6.75523 5.71536L8 6.96014L9.24477 5.71536C9.53192 5.42821 9.99749 5.42821 10.2846 5.71536C10.5718 6.00251 10.5718 6.46808 10.2846 6.75523L9.03986 8L10.2846 9.24477C10.5718 9.53192 10.5718 9.99749 10.2846 10.2846C9.99749 10.5718 9.53192 10.5718 9.24477 10.2846L8 9.03986L6.75523 10.2846C6.46808 10.5718 6.00251 10.5718 5.71536 10.2846C5.42821 9.99749 5.42821 9.53192 5.71536 9.24477L6.96014 8L5.71536 6.75523C5.42821 6.46808 5.42821 6.00251 5.71536 5.71536Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
